export const
  ACTIONS = {
  INIT: '@init',
  CLEAR: 'clear',
  BILLING_ADDRESS_UPDATE: 'billingAddress/update',
  CARDINAL_CRUISE_UPDATE: 'cardinalCruise/update',
  CARDS_UPDATE: 'cards/update',
  CARDS_UPDATE_AFTER_DELETION: 'cards/update-after-deletion',
  CARDS_DELETE: 'cards/delete',
  CARDS_SELECT: 'cards/selectCard',
  CARDS_ADD_CARD_STATE: 'cards/setAddCard',
  CARDS_DESELECT: 'cards/clearSelection',
  PAGESTATE_UPDATE: 'pageState/update',
  PAYMENT_UPDATE: 'payment/update',
  PAYMENT_UPDATE_PAYMENT_PENDING: 'payment/updatePaymentPending',
  PAYMENT_UPDATE_AUTHORISE_RESPONSE: 'payment/updateAuthoriseResponse',
  PAYMENT_AUTHORISE_ERROR: 'payment/authoriseError',
  PAYMENT_CLEAR_AUTHORISE_DATA: 'payment/clearAuthoriseData',
  PAYMENT_RESET_ENCRYPTED_DATA: 'payment/resetCardEncryptedData',
  PAYMENT_PAY: 'payment/pay',
  PAYPAL_STYLES_UPDATE: 'paypalStyles/update',
  TRANSACTION_DETAILS_UPDATE: 'transactionDetails/update',
}
